/** Wrap base64 DER into PEM if headers are missing (signup/pki/start needs full PEM). */
export function ensurePemCertificate(certData: string): string {
  const trimmed = certData?.trim() ?? '';
  if (!trimmed) {
    return trimmed;
  }
  if (trimmed.includes('BEGIN CERTIFICATE')) {
    return trimmed.endsWith('\n') ? trimmed : `${trimmed}\n`;
  }
  const body = trimmed.replace(/\s+/g, '');
  const lines = body.match(/.{1,64}/g) ?? [body];
  return `-----BEGIN CERTIFICATE-----\n${lines.join('\n')}\n-----END CERTIFICATE-----\n`;
}
